export type FileIntakePurpose =
  | 'create_incident'
  | 'create_warranty_case'
  | 'create_ehs_record'
  | 'create_inventory_signal'
  | 'create_fleet_feedback'
  | 'import_data'
  | 'attach_as_evidence'
  | 'generate_summary'
  | 'review_only';

export type FileIntakeActionMode =
  | 'store_only'
  | 'analyze_only'
  | 'suggest'
  | 'create_draft';

export const FILE_INTAKE_PURPOSE_OPTIONS: Array<{
  value: FileIntakePurpose;
  label: string;
  description: string;
}> = [
  { value: 'create_incident', label: 'Create Incident', description: 'Use the file as source material for an incident draft.' },
  { value: 'create_warranty_case', label: 'Create Warranty Case', description: 'Use the file to prepare a warranty or complaint draft.' },
  { value: 'create_ehs_record', label: 'Create Safety Record', description: 'Use the file as safety evidence and build an Environment, Health & Safety draft.' },
  { value: 'create_inventory_signal', label: 'Create Inventory Signal', description: 'Use the file to flag stock variance, low cover, or mismatch.' },
  { value: 'create_fleet_feedback', label: 'Create Fleet Feedback', description: 'Use the file to prepare a fleet account follow-up draft.' },
  { value: 'import_data', label: 'Import Data', description: 'Treat the file as structured register data for the Operational Registers workspace.' },
  { value: 'attach_as_evidence', label: 'Attach As Evidence', description: 'Keep the file as supporting evidence without creating a new draft.' },
  { value: 'generate_summary', label: 'Generate Summary', description: 'Read the file and prepare a summary for management review.' },
  { value: 'review_only', label: 'Review Only', description: 'Store the file for review later without further action.' },
];

export const FILE_INTAKE_ACTION_MODE_OPTIONS: Array<{
  value: FileIntakeActionMode;
  label: string;
  description: string;
}> = [
  { value: 'store_only', label: 'Store Only', description: 'Upload and keep the file without AI follow-up.' },
  { value: 'analyze_only', label: 'Analyze Only', description: 'Store the purpose and prepare AI document context only.' },
  { value: 'suggest', label: 'Analyze And Suggest', description: 'Prepare AI context and suggested next step without creating records.' },
  { value: 'create_draft', label: 'Analyze And Create Draft', description: 'Create a draft signal/record immediately after upload.' },
];

export function purposeRequiresSite(purpose: FileIntakePurpose, actionMode: FileIntakeActionMode): boolean {
  if (actionMode !== 'create_draft') return false;
  return [
    'create_incident',
    'create_warranty_case',
    'create_ehs_record',
    'create_inventory_signal',
    'create_fleet_feedback',
  ].includes(purpose);
}
